import { createFileRoute } from '@tanstack/react-router';
import { ListingDetail } from '@/components/marketplace';

export const Route = createFileRoute('/_dashboard/marketplace/$slug')({
  component: MarketplaceDetailPage,
});

function MarketplaceDetailPage() {
  const { slug } = Route.useParams();
  return <ListingDetail slug={slug} />;
}
